module.exports = __webpack_public_path__ + "static/media/discipline.db2a5403.svg";